import { Component, ReactNode } from 'react';
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';

import IconCheckMark from '../../assets/svg/IconCheckMark';
import { coral } from '../../constants/color';
import isExists from '../../utils/isExists';
import Touchable from '../Touchable';
import styles from './styles';

export interface CheckBoxProps {
  children?: ReactNode;
  label?: string;
  labelTrans?: ReactNode;
  defaultChecked: boolean;
  disable?: boolean;
  onPress?: Function;
  wrapperStyle?: StyleProp<ViewStyle>;
  checkBoxStyle?: StyleProp<ViewStyle>;
  labelFieldStyle?: StyleProp<ViewStyle>;
  labelTextStyle?: StyleProp<TextStyle>;
  checked?: boolean;
  fillColor?: string;
  labelIcon?: ReactNode;
  labelIconEnd?: ReactNode;
  hitSlop?: { top: number; left: number; bottom: number; right: number };
}

interface State {
  checked: boolean;
}

export default class CheckBox extends Component<CheckBoxProps, State> {
  static defaultProps = {
    defaultChecked: false,
    fillColor: coral,
  };
  state: State = {
    checked: this.props.defaultChecked,
  };

  toggleCheckBox = () => {
    if (this.props.disable) {
      return;
    }

    const checked = isExists(this.props.checked)
      ? this.props.checked
      : this.state.checked;

    if (this.props.onPress) {
      this.props.onPress(!checked);
    }

    this.setState({
      checked: !checked,
    });
  };

  render() {
    const checked = isExists(this.props.checked)
      ? this.props.checked
      : this.state.checked;

    return (
      <Touchable
        key="check-box"
        disabled={this.props.disable}
        style={[
          styles.Wrapper,
          this.props.wrapperStyle,
          this.props.disable ? styles.disable : undefined,
        ]}
        onPress={() => this.toggleCheckBox()}
        hitSlop={this.props.hitSlop}
        accessibilityRole="checkbox"
      >
        <View
          key="check-box-icon-box"
          style={[
            checked ? styles.Checked : styles.UnChecked,
            checked && { backgroundColor: this.props.fillColor },
            this.props.checkBoxStyle,
          ]}
          testID={checked ? 'checked' : 'none-checked'}
        >
          <IconCheckMark size={16} />
        </View>

        {(isExists(this.props.label) || isExists(this.props.labelTrans)) && (
          <View
            key="check-box-label"
            style={[styles.labelSectionStyle, this.props.labelFieldStyle]}
          >
            {this.props.labelIcon && (
              <View style={[styles.labelIcon]}>{this.props.labelIcon}</View>
            )}

            <Text
              key="check-box-label-text"
              style={[styles.Label, this.props.labelTextStyle]}
            >
              {this.props.labelTrans || this.props.label}
            </Text>

            {this.props.labelIconEnd && (
              <View style={[styles.labelIconEnd]}>
                {this.props.labelIconEnd}
              </View>
            )}
          </View>
        )}
        {this.props.children}
      </Touchable>
    );
  }
}
